import React from 'react';
import { FlaskConicalIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-white/8 bg-ink-950 py-10" data-id="element-85">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 text-center" data-id="element-86">
        <div className="inline-flex items-center gap-2" data-id="element-87">
          <FlaskConicalIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-88" />
          <span className="font-heading text-sm font-extrabold uppercase tracking-widest text-white" data-id="element-89">
            Nano-Creative Labs
          </span>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-silver/50" data-id="element-90">
          PROMPT LABS + El Ecosistema Nano-Creative. Acceso de por vida con
          actualizaciones incluidas. Garantía de 30 días sin preguntas.
        </p>
        <p className="text-[11px] text-silver/40" data-id="element-91">
          © {new Date().getFullYear()} Nano-Creative Labs. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}